const bondColumnColor = "rgba(255,74,0,0.6)";
const otherKindColumnColor = "rgba(58,147,212,0.6)";
const fontBaseLengthForSp = -15;
const fontBaseLength = -16;
const hideColumn = [];

const columnNameConfig = {
  inland_bond: "国内債券",
  inland_stock: "国内株式",
  advanced_bond: "国際債券",
  advanced_stock: "国際株式",
  emerging_bond: "新興国債券",
  emerging_stock: "新興国株式",
  inland_update: "国内リート", // 文字需要替换
  international_update: "国際リート", // 文字需要替换
  other: "その他", // 文字需要替换
};
const sortConfig = [
  "inland_bond",
  "inland_stock",
  "advanced_bond",
  "advanced_stock",
  "emerging_bond",
  "emerging_stock",
  "inland_update",
  "international_update",
  "other",
];

export {
  columnNameConfig,
  sortConfig,
  hideColumn,
  fontBaseLength,
  fontBaseLengthForSp,
  otherKindColumnColor,
  bondColumnColor,
};
